import FloatingActionButton from '@locus-labs/mol-mobile-floating-action-button'
import React from 'react'
import styled, { withTheme } from 'styled-components'

const ReturnButtonMobile = withTheme(({ theme, T, onClick }) => {
  return <FloatingActionButton data-cy="pinnedLocationReturnButton" iconName="my.location.arrow" onClick={onClick} ariaLabel={T('pinnedLocation:Return To Pinned Location')}/>
})

export default ReturnButtonMobile
